import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import ForecastView from '../../bakery/components/Forecast/ForecastView'
import GOLView from '../../bakery/components/GOL/GOLView'
import BakeryIngredientView from '../../bakery/components/Ingredient/IngredientView'
import MixSkusView from '../../bakery/components/Production/MixSkusView'
import BakeryProductionView from '../../bakery/components/Production/ProductionView'
import QpigListView from '../../bakery/components/QPIG/QpigListView'
import HotFoodCounterTemperatureView from '../../hotfood/components/CounterTemperature/CounterTemperatureView'
import HotFoodDisplayView from '../../hotfood/components/Display/DisplayView'
import HotFoodPizzaPlacementView from '../../hotfood/components/Display/PizzaPlacement'
import HotFoodBatchView from '../../hotfood/components/Production/BatchView'
import HotFoodProductionView from '../../hotfood/components/Production/ProductionView'
import HotFoodReportView from '../../hotfood/components/Report/ReportView'
import ErrorPage from './ErrorPage'
import MaintenancePage from './MaintenancePage'
import NotFoundPage from './NotFoundPage'
import PlannerSelection from './PlannerSelection/PlannerSelection'
import QpigView from './QPIG/QpigView'
import StoreSetting from './StoreSetting'
import AdditionalWaveView from '../../bakery/components/Production/AdditionalWaveView'

const router = createBrowserRouter([
  { path: '/', Component: StoreSetting },
  { path: '/storesetting', Component: StoreSetting },
  { path: '/plannerselection', Component: PlannerSelection },
  { path: '/qpig/:id', Component: QpigView },
  { path: '/error', Component: ErrorPage },
  {
    path: '/service-unavailable',
    element: <MaintenancePage message='' />,
  },
  { path: '/bakeryview', Component: BakeryProductionView },
  { path: '/bakeryforecast', Component: ForecastView },
  { path: '/bakeryingredients', Component: BakeryIngredientView },
  { path: '/mixskusview/:id/:date/:preview', Component: MixSkusView },
  { path: '/qpiglistview', Component: QpigListView },
  { path: '/golview', Component: GOLView },
  { path: '/additionalwave', Component: AdditionalWaveView },
  { path: '/hotfoodview', Component: HotFoodProductionView },
  { path: '/hotfoodDisplay', Component: HotFoodDisplayView },
  { path: '/hotfoodbatch/:id', Component: HotFoodBatchView },
  { path: '/hotfoodbatch', Component: HotFoodBatchView },
  { path: '/hotfoodpizza', Component: HotFoodPizzaPlacementView },
  { path: '/hotfoodreport', Component: HotFoodReportView },
  {
    path: '/hotfoodcountertemperature',
    Component: HotFoodCounterTemperatureView,
  },
  { path: '*', Component: NotFoundPage },
])

const Navigation = () => <RouterProvider router={router} />

export default Navigation
